/**
 * @generated by scripts/architecture-sync.mjs — do not edit.
 *
 * Measured from the tree, so the map's numbers cannot drift from the code.
 * `UNCLAIMED` is what no module on the map covers: run the sync script, then
 * either give an existing module a wider pattern in coverage.json or add the
 * node the repo has been missing.
 */

export const MEASURED = {
  'backend': { count: 14890, loc: 3832173 },
  'backend-booking': { count: 11, loc: 6300 },
  'backend-emails': { count: 6, loc: 2096 },
  'backend-modules': { count: 8, loc: 3018 },
  'backend-payments': { count: 9, loc: 8437 },
  'backend-tests': { count: 192, loc: 60913 },
  'frontend-admin': { count: 129, loc: 20061 },
  'frontend-components': { count: 77, loc: 7224 },
  'frontend-i18n': { count: 70, loc: 10400 },
  'frontend-lib': { count: 38, loc: 4559 },
  'frontend-public': { count: 31, loc: 7215 },
  'frontend-routes': { count: 4, loc: 333 },
  'frontend-saas': { count: 20, loc: 2218 },
  'frontend-src': { count: 27, loc: 3065 },
  'frontend-superadmin': { count: 44, loc: 7494 },
  'frontend-templates': { count: 22, loc: 3852 },
  'frontend-tenant': { count: 3, loc: 428 },
  'frontend-tests': { count: 3, loc: 493 },
  'scripts': { count: 5, loc: 1009 },
  'scripts-qa': { count: 8, loc: 1851 },
}

export const UNCLAIMED = []
